const isPendingUser = (isActivationCompleted?: boolean) => {
    if (typeof isActivationCompleted === 'undefined' || isActivationCompleted === false) {
        return true;
    }
    return false;
};

export { isPendingUser };
